export default {
  data: () => ({
    breakpoint: undefined,
    breakpoints: {
      xs: '0',
      sm: '576px',
      md: '768px',
      lg: '991px',
      xl: '1200px'
    }
  }),
  methods: {
    watchScreenSize () {
			let medianame
      Object.keys(this.breakpoints).forEach(breakpoint => {
        if (window.matchMedia(`(min-width: ${this.breakpoints[breakpoint]})`).matches) {
          medianame = breakpoint
        }
			})
			this.breakpoint = medianame
    }
  },
  created () {
		this.watchScreenSize()
    window.addEventListener("resize", this.watchScreenSize)
    window.addEventListener("orientationchange", this.watchScreenSize)
  },
  destroyed () {
    window.removeEventListener("resize", this.watchScreenSize)
    window.removeEventListener("orientationchange", this.watchScreenSize)
  }
}